import type { fleetState } from '@kanbios/api-client';

type Running = fleetState.components['schemas']['Running'];

/**
 * D55: why « Relancer l'analyse » cannot be clicked now: asked less than 15
 * minutes ago (when, and when again), or the server cannot take it
 * (configuration older than running v11, no access, an enrolment running).
 * Null when it can.
 */
export type RescanHold =
  | { kind: 'cooldown'; requestedAt: string; availableAt: string }
  | { kind: 'blocked'; by: NonNullable<Running['rescanBlockedBy']> };

export function rescanHold(running: Pick<Running, 'rescanRequestedAt' | 'rescanAvailableAt' | 'rescanBlockedBy'>, now = Date.now()): RescanHold | null {
  const availableAt = running.rescanAvailableAt;
  if (availableAt && Date.parse(availableAt) > now) return { kind: 'cooldown', requestedAt: running.rescanRequestedAt ?? availableAt, availableAt };
  return running.rescanBlockedBy ? { kind: 'blocked', by: running.rescanBlockedBy } : null;
}
